export default function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-hierarchy/src/hierarchy/leaves.js
// module id = ../../../../d3-hierarchy/src/hierarchy/leaves.js
// module chunks = 4